export default __webpack_public_path__ + "static/media/kemme.a051d4fb.jpg";